export default __webpack_public_path__ + "static/media/home-banner.2130635a.png";